import Chip from "@mui/material/Chip";
import { CHIP_LABEL, chipToneClass, type ChipTone } from "./format";

// each token colored by its own meaning: BUY/CALL green, SELL/PUT red, SPREAD neutral
const verbTone = (v: string): ChipTone => (/sell/i.test(v) ? "error" : "success");
const instrumentTone = (i: string): ChipTone =>
  /put/i.test(i) ? "error" : /spread/i.test(i) ? "neutral" : "success";

const chipClass = (t: ChipTone): string => `!rounded-full ${CHIP_LABEL} ${chipToneClass(t)}`;

type ActionBadgeProps = {
  verb?: string; // "Buy" / "Sell"
  instrument?: string; // "Call" / "Put" / "Spread"
};

const ActionBadge = ({ verb, instrument }: ActionBadgeProps) => {
  if (!verb && !instrument) return null;
  return (
    <span className="inline-flex items-center gap-1.5">
      {verb && <Chip size="small" label={verb} className={chipClass(verbTone(verb))} />}
      {instrument && <Chip size="small" label={instrument} className={chipClass(instrumentTone(instrument))} />}
    </span>
  );
};

export default ActionBadge;
